import { CheckIcon, XMarkIcon } from "@heroicons/react/24/outline";

export default function CurrencyInput({
  value,
  onChange,
  onSave,
  onCancel,
  inputClassName,
  poundClassName = "text-xs font-bold text-gray-400",
  saveIconClassName = "h-3.5 w-3.5",
}: {
  value: string;
  onChange: (value: string) => void;
  onSave: () => void;
  onCancel: () => void;
  inputClassName: string;
  poundClassName?: string;
  saveIconClassName?: string;
}) {
  return (
    <div className="flex items-center gap-1">
      <span className={poundClassName}>&pound;</span>
      <input
        type="number"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") onSave();
          if (e.key === "Escape") onCancel();
        }}
        className={inputClassName}
        placeholder="0.00"
        autoFocus
      />
      <button
        type="button"
        onClick={onSave}
        className="rounded bg-green-600 p-0.5 text-white hover:bg-green-700"
      >
        <CheckIcon className={saveIconClassName} />
      </button>
      <button
        type="button"
        onClick={onCancel}
        className="rounded bg-gray-200 p-0.5 text-gray-600 hover:bg-gray-300"
        title="Cancel"
      >
        <XMarkIcon className={saveIconClassName} />
      </button>
    </div>
  );
}
